/**
 * Utility functions for Google Tag Manager
 */

export const gtmPush = (eventData) => {
    //alert("gtmPush")
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(eventData);
  }
};

export const trackAccountRegistered = (userData = {}) => {
    //alert("trackAccountRegistered")
  gtmPush({
    event: 'account_registered',
    user_type: userData.userType || 'customer',
    registration_method: userData.method || 'email',
    user_id: userData.userId || null,
    ...userData
  });
};

export const trackCustomEvent = (eventName, eventData = {}) => {
  gtmPush({
    event: eventName,
    ...eventData
  });
};